import React from "react";
import { Typography, Box } from "@mui/material";
import moment from "moment";
import { convertADtoBS } from "../../../components/Calendar/functions/calendarFunctions";
import useAnimationFrame from "../../../hooks/useRequestAnimationFrame";

const FullScreenHeader = (): React.ReactElement => {
  const [date, setDate] = React.useState(moment().valueOf());

  useAnimationFrame((e) => {
    setDate(e.date);
  }, []);

  return (
    <Box
      sx={{
        marginBottom: "48px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minWidth: "unset",
        maxWidth: "1440px",
        width: "100%",
        flexWrap: "wrap"
      }}
    >
      <Typography
        sx={{ fontWeight: 700, fontSize: "24px", lineHeight: "36px", textTransform: "uppercase" }}
      >
        {moment(date).format("h:mm:ss a")}
      </Typography>
      <Box>
        <Typography
          sx={{ fontWeight: 700, fontSize: "24px", lineHeight: "36px", textTransform: "uppercase" }}
        >
          {`${convertADtoBS(moment(date)).formatted5}  `}
        </Typography>
        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: "24px",
            color: "#6F6F6F",
            textAlign: "right"
          }}
        >
          {moment(date).format("MMMM Do YYYY")}
        </Typography>
      </Box>
    </Box>
  );
};

export default FullScreenHeader;
